module.exports = __webpack_public_path__ + "static/NoobsLogoRect-f71296b2e3b1a55063f2a522434bc508.png";